import React from "react";

const Footer = () => {
  return (
    <>
      <p class="footer-text">
        Made with <span>💙</span> By &copy; <a href="https://github.com/abdelm1">Abdelm1</a> 
      </p>
    </>
  );
};

export default Footer;
